import { useEffect } from 'react';
import * as yup from 'yup';
import type { FormDefinition } from '@gov-design-system-ce/react-form-core';
import {
	getFormDefinition,
	useGovForm,
} from '@gov-design-system-ce/react-form-core';
import { RecycleBinType } from '@gov-nx/api';
import { useFiltersStoreFilters } from '@gov-nx/store';
import { toStringDate } from '@gov-nx/utils/common';
import type { PageCode } from '../../definitions/codes';
import type {
	MyFilesDataRequest,
	MyFilesFilterType,
	MyFilesMainFormData,
	MyFilesSource,
} from './context.types';

interface FormInstanceProps {
	code: PageCode;
	defaultValues: MyFilesMainFormData;
}

export function FormInstance({
	code,
	defaultValues,
}: FormInstanceProps): FormDefinition<MyFilesMainFormData> {
	const filters = useFiltersStoreFilters<MyFilesFilterType>(code);

	const formSchema = yup
		.object({
			text: yup.string().optional(),
			selection: yup.object().optional(),
		})
		.required();

	const formMethods = useGovForm<MyFilesMainFormData>({
		formSchema,
		defaultValues,
	});

	useEffect(() => {
		filters?.text && formMethods.setValue('text', filters.text);
		filters?.selection && formMethods.setValue('selection', filters.selection);
		// eslint-disable-next-line react-hooks/exhaustive-deps -- These dependencies are correct
	}, []);

	return getFormDefinition({ formMethods, formSchema });
}

export function prepareQueryData(
	filter: MyFilesFilterType,
	source?: MyFilesSource,
	isFile?: boolean
): MyFilesDataRequest {
	return {
		text: filter.text ?? undefined,
		zdroje: source ?? undefined,
		smazano: 'false',
		razeni: [filter.razeni],
		start: filter.start ?? undefined,
		pocet: filter.pageSize,
		datumVytvoreniOd: filter.datumVytvoreniOd
			? toStringDate(filter.datumVytvoreniOd)
			: undefined,
		datumVytvoreniDo: filter.datumVytvoreniDo
			? toStringDate(filter.datumVytvoreniDo)
			: undefined,
		jeSoubor: isFile ?? undefined,
	};
}

export function prepareQueryBinnedData(
	filter: MyFilesFilterType
): MyFilesDataRequest {
	return {
		typ: RecycleBinType.DOKUMENT,
		razeni: [filter.razeni],
		start: filter.start ?? undefined,
		pocet: filter.pageSize,
	};
}
